/* eslint-disable max-len */
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import React, { Component, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import LocalePreferences from '/@/components/locale-preferences';
import { _ } from '/@/locale';
import { resetProductSelection } from '/@/store/catalog/actions';
import { useCatalogZones } from '/@/store/catalog/apiProviders';
import { getCatalogBrands, getCatalogEnabled } from '/@/store/catalog/selectors';
import { setSelectedFeature } from '/@/store/nav/actions';
import { setPreferences } from '/@/store/session/actions';
import { getSessionCountry, getSessionCrops, getSessionLanguage } from '/@/store/session/selectors';
import { reverse } from '/@/utils/router';
// V3 components
import CatalogHeader from '/@/v3/catalog/catalog-header';
import AppLogo from '/@/v3/components/app-logo';
import BaseBrandSelection from '/@/v3/components/brand-selection';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@connect(
    (state) => ({
        crops: getSessionCrops(state),
        country: getSessionCountry(state),
        language: getSessionLanguage(state),
        brands: getCatalogBrands(state),
    }),
    (dispatch) => bindActionCreators({ setPreferences, resetProductSelection, setSelectedFeature }, dispatch)
)
@autobind
class Splash extends Component {
    initialRender = true;

    static propTypes = {
        size: PropTypes.oneOf(['third', 'half']),
        stretch: PropTypes.bool,
        showPreferences: PropTypes.bool,
        showCatalogSection: PropTypes.bool,
        withOverlay: PropTypes.bool,
        account: PropTypes.bool,
        verifiedView: PropTypes.bool,
    };

    static contextTypes = {
        history: PropTypes.object,
    };

    static defaultProps = {
        size: 'third',
        showPreferences: true,
        showCatalogSection: false,
        account: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            showOverlay: true,
        };
    }

    UNSAFE_componentWillMount() {
        this.image = this.getImage();
    }

    componentDidMount() {
        if (this.initialRender && this.props.withOverlay) {
            const appContent = document.getElementById('app-content');
            appContent.style = 'overflow: hidden';

            new Promise((resolve) => {
                setTimeout(() => {
                    const overlay = document.getElementById('overlay');
                    overlay.style = 'opacity: 0';
                    this.initialRender = false;

                    setTimeout(() => {
                        resolve();
                    }, 500);
                }, 3000);
            }).then(() => {
                this.setState((oldState) => ({
                    ...oldState,
                    showOverlay: false,
                }));

                appContent.style = 'auto';
            });
        }
    }

    getImage() {
        const { crops } = this.props;
        const images = { corn: 2, soy: 1 };
        const crop = crops[Math.floor(Math.random() * crops.length)];
        const index = Math.floor(Math.random() * images[crop.identifier]) + 1;
        return [crop.identifier, index].join('-');
    }

    handleClickCatalogItem(type) {
        this.props.resetProductSelection();
        this.props.setSelectedFeature({ view: 'catalog.ProductSelection', selectedFeature: 'catalog' });
        this.context.history(
            reverse('catalog.ProductSelection', {
                params: { type },
            })
        );
    }

    handleClickLogo() {
        this.context.history(reverse('Login'));
    }

    renderOverlay() {
        return (
            <div className={styles.overlay} id='overlay'>
                <AppLogo onClick={this.handleClickLogo} className={styles.overlayLogo} />
                <Title align='center'>¡Te damos la bienvenida a plataforma técnica de BAYER!</Title>
            </div>
        );
    }

    render() {
        const account = this.props.account;
        return (
            <div
                className={classNames(styles.root, styles[`size-${this.props.size}`], {
                    [styles.stretch]: this.props.stretch,
                })}
            >
                {this.props.withOverlay && this.state.showOverlay && this.renderOverlay()}

                <div
                    className={classNames(styles.main, account ? styles.imageAccount : styles.image, {
                        [styles.slim]: !this.props.headTitle,
                    })}
                >
                    <div className={classNames(styles.head, account ? styles.headAccount : '')}>
                        <AppLogo onClick={this.handleClickLogo} />
                        {this.props.headTitle && (
                            <React.Fragment>
                                <div className={styles.divider} />
                                <Title size='xl' className={styles.title} align='center'>
                                    {this.props.headTitle}
                                </Title>
                            </React.Fragment>
                        )}

                        {this.props.headSubtitle && (
                            <Title className={styles.subtitle} align='center'>
                                {this.props.headSubtitle}
                            </Title>
                        )}
                    </div>
                    <div className={classNames(styles.container, this.props.verifiedView ? styles.verified : '')}>
                        <div className={styles.wrapper}>
                            <div className={styles.content}>{this.props.children}</div>
                            {this.props.showPreferences && (
                                <div
                                    className={classNames(styles.preferences, account ? styles.preferencesAccount : '')}
                                >
                                    <LocalePreferences
                                        openUp
                                        appearance='row'
                                        showLabels={false}
                                        country={this.props.country.id}
                                        language={this.props.language}
                                        onChange={this.props.setPreferences}
                                        showCountry={!this.props.verifiedView}
                                        upperCase
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    {this.props.showCatalog && this.props.showCatalogSection && (
                        <div className={styles.catalogSelection}>
                            <CatalogHeader />
                            <div className={styles.selectionWrapper}>
                                <BaseBrandSelection
                                    title={_('Catálogo')}
                                    subtitle={_('Seleccioná una marca para acceder a su catálogo.')}
                                    brands={this.props.brands}
                                    onClick={this.handleClickCatalogItem}
                                    isLogin
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const SplashWrapped = (props) => {
    const catalogZonesQuery = useCatalogZones({ page: 1, pageSize: 10000, crop: props.type, type: 'catalog' });
    const catalogZones = useMemo(() => catalogZonesQuery.data?.results || [], [catalogZonesQuery.data?.results]);

    const catalogEnabled = useSelector((state) => getCatalogEnabled(state, catalogZones));
    return <Splash {...props} showCatalog={catalogEnabled}></Splash>;
};

export default SplashWrapped;
